import gql from 'graphql-tag';

export const addKontakt = gql`
  mutation addKontakt($input: [KontaktInput!]!) {
    response: addKontakt(inputKontakt: $input) {
      id
    }
  }
`;
